import depositSummaryReducer from './DepositSummary/depositSummaryEntity';
import { createSelector } from 'reselect';
import { get } from 'lodash';
import { combineReducers } from 'redux';
import userDataReducer from './UserData/userDataEntity';
import transactionsReducer from './Transactions/transactionsEntity';
import transactionReducer from './Transaction/transactionEntity';
import routesReducer from './Routes/routesEntity';
import searchReducer from './Search/searchEntity';
import reportingReducer from './Reporting/reportingEntity';
import merchantsReducer from './Merchants/merchantsEntity';
import chargebackReducer from './Chargeback/chargebackEntity';
import chargebacksReducer from './Chargebacks/chargebacksEntity';
import statementsReducer from './Statements/statementsEntity';
import selfReducer from './Self/selfEntity';
import bankReducer from './Bank/bankEntity';
import adjustmentsReducer from './Adjustments/adjustmentsEntity';
import batchesReducer from './Batches/batchesEntity';
import fraudReducer from './Fraud/fraudEntity';
import kpiReducer from './Dashboard/Widgets/kpiEntity';
import csvReducer from './CSVs/csvEntity';
import refundReducer from './Refund/refundEntity';
import voidReducer from './Void/voidEntity';
import captureReducer from './Capture/captureEntity';
import tableReducer from './Table/tableEntity';
import supportReducer from './Support/supportEntity';
import userSettingsReducer from './UserSettings/userSettingsEntity';
import widgetSettingsReducer from './WidgetSettings/widgetSettingsEntity';
import userManagementReducer from './UserManagement/userManagementEntity';
import merchantManagementReducer from './MerchantManagement/merchantManagementEntity';
import reservesReducer from './Reserves/reservesEntity';
import exportsReducer from './Exports/exportsEntity';
import { webhookReducer, webhooksReducer, webhookResendReducer } from './WebhookLog/webhookLogEntity';
import billingReducer from './Billing/billingEntity';
import accountAgreementReducer from './AccountAgreement/accountAgreementEntity';
import paymentRoutingReducer from './PaymentRouting/paymentRoutingEntity';
import rulesReducer from './PaymentRouting/UserRoutingRules/RoutingRules/rulesEntity';
import payoutAccountsReducer from './PayoutAccounts/payoutAccountEntity';
import payoutsReducer from './Payouts/payoutsEntity';
import erroredPayoutsReducer from './Payouts/ErroredPayouts/erroredPayoutsEntity';
import payoutRecipientsReducer from './PayoutRecipients/payoutRecipientsEntity';
import pendingPayoutsReducer from './PendingPayouts/pendingPayoutsEntity';
import payoutBatchesReducer from './PayoutBatches/payoutBatchesEntity';
import payoutBatchReducer from './PayoutBatch/payoutBatchEntity';
import payoutReducer from './Payout/payoutEntity';
import payoutRecipientReducer from './PayoutRecipient/payoutRecipientEntity';
import spendbacksReducer from './Spendbacks/spendbacksEntity';
import spendbackReducer from './Spendback/spendbackEntity';
import gatewaysReducer from './Gateways/gatewaysEntity';
import signupReducer from './Signup/signupEntity';
import resellerWidgetSettingsReducer from './ResellerDashboard/Widgets/ResellerWidgetSettings/resellerWidgetSettingsEntity';
import resellerKpiReducer from './ResellerDashboard/Widgets/kpiEntity';
import residualsReducer from './Residuals/residualsEntity';
import agentResidualsReducer from './AgentResiduals/agentResidualsEntity';
import boardingStatusSummaryReducer from './BoardingStatusSummaryWidget/boardingStatusSummaryEntity';
import processorOnboardingReducer from './ProcessorOnboarding/processorOnboardingEntity';
import apmReducer from './Apms/apmEntity';
import prevetFormReducer from './MerchantDetailsPage/PrevetForm/prevetFormEntity';
import leadToLiveReducer from './LeadToLive/leadToLiveEntity';
import merchantOnboardingReducer from './LeadToLive/merchantOnboardingEntity';
import applicationsReducer from './LeadToLive/applicationEntity';
import overviewReducer from './ResellerOverview/ResellerOverviewEntity';
import prevetReducer from './MerchantDetailsPage/prevetEntity';
import createApplicationReducer from './LeadToLive/createApplicationEntity';
import merchantDetailsReducer from './MerchantDetailsPage/merchantDetailsEntity';
import domoReportReducer from './ResellerDashboard/domoReportEntity';

export const entities = combineReducers({
    depositSummary: depositSummaryReducer,
    adjustments: adjustmentsReducer,
    agentResiduals: agentResidualsReducer,
    bankInfo: bankReducer,
    batches: batchesReducer,
    billing: billingReducer,
    boardingStatusSummary: boardingStatusSummaryReducer,
    capture: captureReducer,
    chargeback: chargebackReducer,
    chargebacks: chargebacksReducer,
    csv: csvReducer,
    support: supportReducer,
    fraud: fraudReducer,
    kpi: kpiReducer,
    resellerKpi: resellerKpiReducer,
    merchantManagement: merchantManagementReducer,
    merchants: merchantsReducer,
    payoutAccounts: payoutAccountsReducer,
    payout: payoutReducer,
    payouts: payoutsReducer,
    payoutRecipients: payoutRecipientsReducer,
    pendingPayouts: pendingPayoutsReducer,
    erroredPayouts: erroredPayoutsReducer,
    payoutBatches: payoutBatchesReducer,
    payoutBatch: payoutBatchReducer,
    payoutRecipient: payoutRecipientReducer,
    processorOnboarding: processorOnboardingReducer,
    spendback: spendbackReducer,
    spendbacks: spendbacksReducer,
    paymentRouting: paymentRoutingReducer,
    refund: refundReducer,
    reporting: reportingReducer,
    reserves: reservesReducer,
    residuals: residualsReducer,
    rules: rulesReducer,
    exports: exportsReducer,
    routes: routesReducer,
    search: searchReducer,
    self: selfReducer,
    signup: signupReducer,
    statements: statementsReducer,
    table: tableReducer,
    accountAgreement: accountAgreementReducer,
    transaction: transactionReducer,
    transactions: transactionsReducer,
    userData: userDataReducer,
    userManagement: userManagementReducer,
    userSettings: userSettingsReducer,
    void: voidReducer,
    widgetSettings: widgetSettingsReducer,
    resellerWidgetSettings: resellerWidgetSettingsReducer,
    webhooks: webhooksReducer,
    webhook: webhookReducer,
    webhookResend: webhookResendReducer,
    gateways: gatewaysReducer,
    apms: apmReducer,
    prevetForm: prevetFormReducer,
    leadToLive: leadToLiveReducer,
    merchantOnboarding: merchantOnboardingReducer,
    applications: applicationsReducer,
    overview: overviewReducer,
    prevet: prevetReducer,
    createApplication: createApplicationReducer,
    merchantDetails: merchantDetailsReducer,
    domoReport: domoReportReducer
});

export const getEntities = createSelector(
    (state) => state,
    (state) => get(state, 'entities')
);

export const getEntityByName = createSelector(
    getEntities,
    (state, name) => name,
    (entities, name) => get(entities, name)
);
